export type BlogCategory = 'Lifestyle' | 'Travel' | 'Community' | 'Tips';

export interface FaqItem {
  question: string;
  answer: string;
}

export interface Source {
  title: string;
  url: string;
  description: string;
}

export interface BlogPost {
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  primaryKeyword: string;
  supportingKeywords: string[];
  publishDate: string; // YYYY-MM-DD
  lastModified: string; // YYYY-MM-DD
  readingTime?: number; // minutes
  excerpt: string;
  content: string; // markdown
  author: string;
  categories: BlogCategory[];
  coverImage?: string;
  coverImagePosition?: string; // CSS object-position for the detail-page cover crop
  imageAlt: string;
  ogImage?: string; // per-post OG image path, falls back to /og-image.jpg
  tags: string[];
  faqSchema?: FaqItem[];
  sources?: Source[];
  canonicalUrl: string;
}

export function estimateReadingTime(content: string): number {
  const words = content.trim().split(/\s+/).length;
  return Math.max(1, Math.round(words / 200));
}
